import { styled } from '@mui/system'
import ModalUnstyled from '@mui/base/ModalUnstyled'

const StyledModal = styled(ModalUnstyled)`
	position: fixed;
	z-index: 1300;
	right: 0;
	bottom: 0;
	top: 0;
	left: 0;
	overflow: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem 0;
`

const Backdrop = styled('div')`
	z-index: -1;
	position: fixed;
	right: 0;
	bottom: 0;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.5);
	-webkit-tap-highlight-color: transparent;
`
export { StyledModal, Backdrop }
